import { render, staticRenderFns } from "./catalog-create-page.vue?vue&type=template&id=2f177767&"
import script from "./catalog-create-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-create-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports